import {
    ContainerAvailabilityForecastContainerStatuses,
    ContainerAvailabilityForecastIncludeOptions,
} from 'app/enums/common.enums'

export const containerStatusLabelMap: Record<
    ContainerAvailabilityForecastContainerStatuses,
    string
> = {
    [ContainerAvailabilityForecastContainerStatuses.ToBeProcessed]: 'TO_BE_PROCESSED',
    [ContainerAvailabilityForecastContainerStatuses.InProcess]: 'IN_PROCESS',
    [ContainerAvailabilityForecastContainerStatuses.Processed]: 'PROCESSED',
    [ContainerAvailabilityForecastContainerStatuses.InPreconditioning]:
        'IN_PRECONDITIONING',
    [ContainerAvailabilityForecastContainerStatuses.Preconditioned]:
        'PRECONDITIONED',
}

export const includeLabelMap: Record<ContainerAvailabilityForecastIncludeOptions, string> = {
    [ContainerAvailabilityForecastIncludeOptions.IncludeNotStartedOrders]: 'NOT_STARTED_ORDERS',
    [ContainerAvailabilityForecastIncludeOptions.IncludePreBookings]: 'PRE_BOOKINGS',
    [ContainerAvailabilityForecastIncludeOptions.IncludeAllDualContainers]: 'ALL_DUAL_CONTAINERS',
}
